// extracted by mini-css-extract-plugin
export default {"searchInput":"debounceInputBox_styles_searchInput__lQY-j","searchInputWithIcon":"debounceInputBox_styles_searchInputWithIcon__RA21k"};